import PropTypes from 'prop-types'

export const SelectWrapper = ({ label, children, required, styles: overrideStyles = {} }) => {
  const hasFloatingLabel = String(label || '').trim().length > 0
  const styles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    placeholder: (provided) => ({
      ...provided,
      color: '#78909C',
      fontSize: '14px'
    }),
    ...overrideStyles
  }

  return (
    <div className='relative z-11'>
      {hasFloatingLabel && (
        <label className='absolute -top-2 left-2 px-1 pl-1 z-10 bg-white text-blue-gray-400 font-light text-[11px] '>
          {required ? <span>{label} <span className='text-red-500'>*</span></span> : label}
        </label>
      )}
      {children(styles)}
    </div>
  )
}

SelectWrapper.propTypes = {
  label: PropTypes.string,
  children: PropTypes.func,
  required: PropTypes.bool,
  styles: PropTypes.object
}
